import { fitroomViewportModuleContext } from '@seddi/ui-babylon-fitroom';
import { Avatar } from '../../avatars';
import { SessionStorage } from '../../session';
import { homeActions } from '../slices/homeSlice';
import { homeStateExt } from '../store/homeStateExt';
import { HomeDispatch, HomeGetState } from '../store/homeStore';

/**
 * Reset avatar state.
 * @param dispatch Redux dispatch function.
 * @param getState Redux state accessor.
 */
export function resetAvatar(dispatch: HomeDispatch, getState: HomeGetState) {
  const avatarId = getState().avatarId;

  if (avatarId === null) {
    return;
  }

  // Update state.
  homeStateExt.avatar = null;
  dispatch(homeActions.unsetAvatar());

  // TODO: Update visualization.
}

/**
 * Update avatar.
 * @param dispatch Redux dispatch function.
 * @param avatar Avatar.
 */
export async function updateAvatar(dispatch: HomeDispatch, avatar: Avatar) {
  // Update state.
  homeStateExt.avatar = avatar;
  dispatch(homeActions.setAvatar(avatar.id));

  // Update cache.
  SessionStorage.pushData({ avatarId: avatar.id });

  // update visualization.
  const sex = avatar.sex;
  const shape = new Float32Array(avatar.smplShape);
  const context = fitroomViewportModuleContext();
  context.updateAvatarTextures({ sex });
  context.updateAvatarGeometry({ sex, shape });
}
